import { render, staticRenderFns } from "./HomePickuplist.vue?vue&type=template&id=6257a0fa&scoped=true&"
import script from "./HomePickuplist.vue?vue&type=script&lang=ts&"
export * from "./HomePickuplist.vue?vue&type=script&lang=ts&"
import style0 from "./HomePickuplist.vue?vue&type=style&index=0&id=6257a0fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257a0fa",
  null
  
)

export default component.exports